import React, {PureComponent} from "react";
import {IReducerState} from "../../../../states/renditionStates";
import * as asyncStateAction from '../../../../actions/asyncStateAction';
import {connect} from "react-redux";
import serviceConfig from "../../../../services/servicesConfig";
import '../../../../../style/features/globalMarketData.scss';
import _ from 'lodash';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import $ from "jquery";

interface IGlobalMarketDataContentFunctionalProps {
    loadGlobalMarketData: (documentId: string, type: string) => {};
}

interface IGlobalMarketDataContentVariableProps {
    globalMarketData: any;
}

interface IGlobalMarketDataContentProps extends IGlobalMarketDataContentFunctionalProps, IGlobalMarketDataContentVariableProps {
}

export class GlobalMarketDataContent extends PureComponent<IGlobalMarketDataContentProps, any> {
    public footerRef: any = React.createRef();
    private tableData: any;
    private subTitleCols: any;

    constructor(props: IGlobalMarketDataContentProps) {
        super(props);
        this.props.loadGlobalMarketData(window.HTML_RENDITION.doc_id, "GLOBALMARKETDATA");
        this.tableData = undefined;
        this.state = {
            rowNumber: 0,
            refCell: null
        };
    }

    public componentWillReceiveProps(nextProps: Readonly<IGlobalMarketDataContentProps>, nextContext: any) {
        const globalMarketData = nextProps.globalMarketData.data;
        if (!_.isUndefined(globalMarketData)) {
            this.tableData = globalMarketData.tableData;
        }
    }

    public componentDidMount() {
        $(window).on('resize', _.debounce(_.bind(this.resizeTableBody, this), 200));
    }

    public componentWillUnmount() {
        $(window).off('resize', _.debounce(_.bind(this.resizeTableBody, this), 200));
    }

    public componentDidUpdate(prevState: any) {
        if (_.isUndefined(prevState.refCell) && _.isNull(this.state.refCell)) {
            this.setState({
                refCell: this.footerRef.current
            });
            this.resizeTableBody();
        }
    }

    public resizeTableBody() {
        if (this.footerRef.current && $('.rendition-modal-window').length) {
            const tableContentHeightWithoutBody = this.footerRef.current?.clientHeight + 28 + 35 + 65;
            const modalHeight = $('.rendition-modal-window').height() || 0;
            $('#globalMarketData .table3, #globalMarketData .table4').height(modalHeight - tableContentHeightWithoutBody);
        }
    }

    public getTabs() {
        const { globalMarketData } = this.props;

        const { rowNumber } = this.state;
        const tabs: Array<any> = [];

        for (let index = 0; index < globalMarketData.data.tableData.length; index++) {
            const buttonClassName = (rowNumber == index) ? 'tab-link focus' : 'tab-link';
            tabs.push(<div tabIndex={0} role="link" aria-label={globalMarketData.data.tableData[index].name} className={buttonClassName} onClick={() => this.clickTab(index)}>{globalMarketData.data.tableData[index].name}</div>);
        }
        return <div className='tabs'>{tabs}</div>;
    }

    public clickTab(index: number) {
        this.setState({ rowNumber: index });

        setTimeout(() => {
            $('.table4 .rt-tr-group>.rt-tr>.rt-td, .table2 .rt-thead.-header>.rt-tr>.rt-th').css({
                'width': '100px',
                'max-width': '100px',
                'flex': '100 0 auto'
            });
            $('.table4 .rt-table>div.rt-tbody, .table2 .rt-table>div.rt-thead').css({
                'min-width': $('.table4 .rt-table>div.rt-thead.-header').width() || 0
            });
            for (let i = 0; i < this.subTitleCols.length; i++) {
                const j: number = i + 1;
                $('.table2 .rt-table>div.rt-thead.-headerGroups .rt-th:nth-child(' + j + ')').css({
                    'width': this.subTitleCols[i] * 100 + 'px',
                    'max-width': this.subTitleCols[i] * 100 + 'px'
                });
            }
        }, 50);
    }

    public render() {
        if (_.isUndefined(this.tableData)) {
            return (<div></div>);
        }
        return (this.renderTable(this.tableData));
    }

    public renderTable(globalMarketData:any) {
        let rowLength: number = 0;
        globalMarketData.forEach((element: any) => {
            if (element.rows.length > rowLength) {
                rowLength = element.rows.length;
            }
        });

        const row = globalMarketData[this.state.rowNumber];
        // render header
        const colNames: Array<string> = [];
        const columns1: Array<any> = [];
        const columns2: Array<any> = [];
        const subColumnContainer: Array<any> = [];
        row.columns.forEach((element: any) => {
            if (!element.columns) { // here's the content for the 1st/3rd table
                columns1.push({
                    Header: '',
                    headerClassName: 'row1 ' + element.dataIndex,
                    columns: [{
                        Header: element.text,
                        accessor: element.dataIndex, // String-based value accessors!
                        width: 200,
                        headerClassName: 'row2 ' + element.dataIndex
                    }],
                    noDataText: '',
                });
                colNames.push(element.dataIndex);
            } else {                // here's the content for the 2nd/4th table
                const subColumns: Array<any> = [];
                element.columns.forEach((subElement: any) => {
                    subColumns.push({
                        Header: subElement.text,
                        accessor: subElement.dataIndex,
                        headerClassName: 'row2 ' + subElement.dataIndex,
                        width: 100,
                        minWidth: 100
                    });
                    colNames.push(subElement.dataIndex);
                });
                columns2.push({
                    Header: element.text,
                    headerClassName: 'row1',
                    columns: subColumns,
                    noDataText: ''
                });
                subColumnContainer.push(subColumns.length);
            }
        });
        this.subTitleCols = subColumnContainer;

        // render data
        const data: Array<any> = [];
        row.rows.forEach((cell: any) => {
            const obj: any = {};
            colNames.forEach((colName: any) => {
                obj[colName] = cell.cells[colName].value;
            });
            data.push(obj);
        });

        // render footer
        const footers: Array<any> = [];
        row.footers.forEach((footer: any) => {
            footers.push(<div className="footer-row" dangerouslySetInnerHTML={{ __html: footer.text }} />);
        });

        return (
            <div id='globalMarketData'>
                {this.getTabs()}
                <div style={{ display: 'flex' }}>
                    <ReactTable
                        className='table1 odd'
                        columns={columns1}
                        showPagination={false}
                        pageSize={rowLength}
                        sortable={false}
                        minRows={0}
                        resizable={false}
                    />
                    <ReactTable
                        className='table2 even'
                        columns={columns2}
                        minRows={0}
                        showPagination={false}
                        pageSize={rowLength}
                        sortable={false}
                        onResizedChange={(newResized: any) => {
                            const num = $('.' + newResized[newResized.length - 1].id).index() + 1;
                            const newResizedVal = newResized[newResized.length - 1].value;
                            $('.table4 .rt-tr-group>.rt-tr>.rt-td:nth-child(' + num + ')').css({
                                'width': newResizedVal,
                                'max-width': newResizedVal,
                                'flex': newResizedVal + ' 0 auto'
                            });
                            $('.table4 .rt-table>div.rt-tbody').css({
                                'min-width': (parseFloat($('.table2 .rt-thead.-header').css('min-width')) || 0) + 16 + 'px'
                            });
                        }}
                    />
                </div>
                <div style={{ display: 'flex' }}>
                    <ReactTable
                        className='table3 odd'
                        columns={columns1}
                        data={data}
                        showPagination={false}
                        pageSize={rowLength}
                        sortable={false}
                        minRows={0}
                    />
                    <ReactTable
                        className='table4 even'
                        columns={columns2}
                        data={data}
                        minRows={0}
                        showPagination={false}
                        pageSize={rowLength}
                        sortable={false}
                        getProps={() => {
                            return {
                                onScroll: (e: any) => {
                                    const leftTbody: any = document.querySelector('.table3 .rt-table .rt-tbody') || {};
                                    leftTbody.scrollTop = e.target.scrollTop;
                                    const topThead: any = document.querySelector('.table2 .rt-table') || {};
                                    topThead.scrollLeft = e.target.scrollLeft;
                                    if (e.target.scrollLeft > topThead.scrollLeft) {
                                        e.target.scrollLeft = topThead.scrollLeft;
                                    }
                                }
                            };
                        }}
                        getTdProps={(state: any, rowInfo: any, column: any, instance: any) => {
                            const value = rowInfo.row[column.id];
                            const hasBracket = value.toString().charAt(0) == "(";
                            return {
                                style: {
                                    color: hasBracket ? '#e60000' : '#333'
                                }
                            };
                        }}
                    />
                </div>
                <div className='footer-sub-container' ref={this.footerRef}>{footers}</div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        globalMarketData: state.asyncStateReducer.globalMarketData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadGlobalMarketData: (documentId: string, type: string) =>
            dispatch(asyncStateAction.fetchGlobalMarketData(serviceConfig.GET_GLOBAL_MARKET_DATA, documentId, type)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMarketDataContent);
